import * as ko from 'knockout';
class ServiceProviderMultiSelectViewModel {
    constructor(params) {
        // Actions
        this.openModal = () => {
            this.modalVisible(true);
        };
        this.closeModal = () => {
            // Always apply selections when the modal closes (backdrop, X button, or "Übernehmen").
            this._applyAndClose();
        };
        this.clearAllSelections = (data, event) => {
            event.stopPropagation();
            const selections = Object.assign({}, this.formViewModel.selectedServiceProviders());
            selections[this.fieldName] = [];
            this.formViewModel.selectedServiceProviders(selections);
            const customEntries = Object.assign({}, this.formViewModel.customServiceProviders());
            customEntries[this.fieldName] = [];
            this.formViewModel.customServiceProviders(customEntries);
            this.formViewModel.updateServiceProviderFieldValue(this.fieldName);
        };
        // Read the observable here so the binding stays reactive
        this.isSelected = (provider) => {
            const fieldSelections = this.formViewModel.selectedServiceProviders()[this.fieldName] || [];
            return fieldSelections.some(p => p.id === provider.id);
        };
        this.toggleSelection = (provider) => {
            this.formViewModel.toggleServiceProviderSelection(this.fieldName, provider);
        };
        this.addCustomEntry = () => {
            const val = this.customValue().trim();
            if (val) {
                this.formViewModel.addCustomServiceProvider(this.fieldName, val);
                this.customValue("");
            }
        };
        this.applySelections = () => {
            this.closeModal();
        };
        this.fieldName = params.fieldName;
        this.placeholder = params.placeholder || 'Dienstleister auswählen';
        this.formViewModel = params.formViewModel;
        this.customValue = ko.observable("");
        this.modalVisible = ko.observable(false);
        this.searchQuery = ko.observable("");
        // Grouped (by type) and filtered providers
        this.groupedFilteredProviders = ko.computed(() => {
            const providers = this.formViewModel.getFilteredServiceProvidersForField(this.fieldName);
            const query = this.searchQuery().toLowerCase();
            let filtered = providers;
            // 1. Filter by search query (name)
            if (query.length > 0) {
                filtered = providers.filter(p => (p.name && p.name.toLowerCase().includes(query)) ||
                    (p.displayName && p.displayName.toLowerCase().includes(query)));
            }
            // 2. Group by type (role label)
            const groups = {};
            const groupOrder = [];
            filtered.forEach(p => {
                const groupKey = p.type || "Sonstige";
                if (!groups[groupKey]) {
                    groups[groupKey] = [];
                    groupOrder.push(groupKey);
                }
                groups[groupKey].push(p);
            });
            // 3. Convert to array for the view
            return groupOrder.map(key => ({
                groupName: key,
                providers: groups[key]
            }));
        });
        // Selection summary text shown on the trigger
        this.selectionSummary = ko.computed(() => {
            const selections = this.formViewModel.selectedServiceProviders()[this.fieldName] || [];
            const customEntries = this.formViewModel.customServiceProviders()[this.fieldName] || [];
            const allSelections = [...selections, ...customEntries];
            if (allSelections.length === 0) {
                return this.placeholder;
            }
            else if (allSelections.length === 1) {
                return allSelections[0].displayName || allSelections[0].name || "Ausgewählt";
            }
            else {
                return `${allSelections.length} Dienstleister ausgewählt`;
            }
        });
        this.hasSelections = ko.computed(() => {
            const selections = this.formViewModel.selectedServiceProviders()[this.fieldName] || [];
            const customEntries = this.formViewModel.customServiceProviders()[this.fieldName] || [];
            return selections.length > 0 || customEntries.length > 0;
        });
    }
    _applyAndClose() {
        // Write current selection into the field value
        this.formViewModel.updateServiceProviderFieldValue(this.fieldName);
        // Close modal and reset search
        this.modalVisible(false);
        this.searchQuery("");
    }
}
// Register the component
ko.components.register('service-provider-multi-select', {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            return new ServiceProviderMultiSelectViewModel(params);
        }
    },
    template: { element: 'service-provider-multi-select-template' }
});
// Named export for unit tests (the registration above wires the runtime component)
export { ServiceProviderMultiSelectViewModel };
// Export to ensure the file is included in the bundle
export default {};
